import { NavLink } from "react-router-dom";
import './PanelItem.css'

const PanelItem = ({ title, panelState, url, external }) => {
  if (external) {
    return (
      <a
        href={url}
        className={`panel-item ${panelState}`}
        target="_self"
        rel="noopener noreferrer"
      >
        {title}
      </a>
    );
  }
  return (
    <NavLink
      to={url}
      className={`panel-item ${panelState}`}
      activeClassName="active"
    >
      {title}
    </NavLink>
  );
};

export default PanelItem;